import React, { useState } from 'react';
import Page from 'src/components/Page';
import { Container, makeStyles } from '@material-ui/core';
import invoiceService from 'src/services/invoiceService';
import Results from 'src/views/crm/Invoices/List/Results';
import { useLocation, useParams } from 'react-router';
import layoutService from 'src/services/layoutService';

const useStyles = makeStyles(theme => ({
	root: {
		backgroundColor: theme.palette.background.dark,
		minHeight: '100%',
		paddingTop: theme.spacing(3),
		paddingBottom: theme.spacing(3),
		display: 'flex',
    flexDirection: 'column'
  },
  container: {
		display: 'flex',
    flexGrow: 1
  }
}))

function Invoices() {
	const classes = useStyles();
	const [isLoading, setIsLoading] = useState(false);
	const [dataSource, setDataSource] = useState(null);
	const { contractLineId } = useParams(); 
	const { entity } = useLocation().state;
		
	const pages = [
		{ title: 'Dashboard', link: '/app' },
		{ title: `Fornitura #${contractLineId}`, link: `/app/supply/${contractLineId}`, state: { entity }},
		{ title: 'Fatture' }
	];
	layoutService.setBreadcrumbs(pages);
	
	function getData(params, loading) {
		if(loading) {
			setIsLoading(true);
			setDataSource(null);
		}	

		let _params = {
			...params,
			contractId: entity?.contract?.id
		}

		invoiceService.search(_params)
			.then(response => {
				let res = {
					...response.data,
					start: params?.start
				};
				
				setDataSource(res);
			})
			.finally(() => setIsLoading(false));
	};

	return (
		<Page className={classes.root} title="Fatture">
			<Container maxWidth={false} className={classes.container}>
				<Results
					dataSource={dataSource}
					reload={(res, loading) => getData(res, loading)}
					isLoading={isLoading}
				/>			
			</Container>
		</Page>
	)
}

export default Invoices;